module.exports = __webpack_public_path__ + "img/avatar0.9877a967.png";